import base from "../baseurl";
import token from "../getTk";

const showAll = async () => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("users/advisors", {
      json: {},
      timeout: false,
    })
    .json();
  return Create;
};

export default showAll;
